/* Renders a rating histogram into the Klaviyo Reviews summary block.
   Replaces Klaviyo's default summary content (fit slider / size / age /
   View all button) with: average rating + stars + total review count +
   per-star horizontal bars. Data comes from the Klaviyo client_reviews
   public API (summary.rating_histogram), which is the same endpoint the
   Klaviyo widget itself calls. */
(function () {
  /* SUKwtm is Gentle Fawn's public Klaviyo company ID. It's visible in
     every klaviyo.com URL on the storefront — not a secret. */
  var COMPANY_ID = 'SUKwtm';

  function getProductId() {
    var el = document.getElementById('fulfilled-reviews-all');
    return el && el.getAttribute('data-id');
  }

  function fetchData(productId) {
    var url = 'https://fast.a.klaviyo.com/reviews/api/client_reviews/' + productId
      + '/?product_id=' + productId + '&company_id=' + COMPANY_ID
      + '&limit=50&offset=0&sort=3&filter=&type=reviews&media=false';
    return fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function buildStarsHTML(avg) {
    var fillPct = Math.max(0, Math.min(5, avg)) / 5 * 100;
    return ''
      + '<span class="gf-reviews-stars__bg" aria-hidden="true">★★★★★</span>'
      + '<span class="gf-reviews-stars__fg" aria-hidden="true" style="width:' + fillPct + '%">★★★★★</span>';
  }

  function render(summary) {
    var avg = Number(summary.star_rating || 0);
    var total = Number(summary.review_count || 0);
    var hist = summary.rating_histogram || [0, 0, 0, 0, 0]; /* [1★, 2★, 3★, 4★, 5★] */

    var html = '<div class="gf-reviews-histogram">'
      + '<div class="gf-reviews-histogram__top">'
      + '<span class="gf-reviews-histogram__avg">' + avg.toFixed(1) + '</span>'
      + '<span class="gf-reviews-stars">' + buildStarsHTML(avg) + '</span>'
      + '</div>'
      + '<div class="gf-reviews-histogram__count">Based on ' + total + ' review' + (total === 1 ? '' : 's') + '</div>'
      + '<div class="gf-reviews-histogram__bars">';

    for (var i = 5; i >= 1; i--) {
      var count = hist[i - 1] || 0;
      var pct = total > 0 ? (count / total) * 100 : 0;
      html += '<div class="gf-reviews-histogram__row">'
        + '<div class="gf-reviews-histogram__row-label">' + i + ' <span aria-hidden="true">★</span></div>'
        + '<div class="gf-reviews-histogram__row-track">'
        + '<div class="gf-reviews-histogram__row-fill" style="width:' + pct + '%"></div>'
        + '</div>'
        + '<div class="gf-reviews-histogram__row-count">' + count + '</div>'
        + '</div>';
    }

    html += '</div></div>';
    return html;
  }

  function tryInject() {
    var wrapper = document.getElementById('klaviyo-product-reviews-wrapper');
    if (!wrapper) return false;
    var slot = wrapper.querySelector('.kl_reviews__summary__rating--1-1');
    if (!slot) return false;
    if (slot.dataset.gfHistogramInjected) return true;

    var productId = getProductId();
    if (!productId) return true; /* wrapper present but no PID — give up */

    slot.dataset.gfHistogramInjected = '1';
    fetchData(productId).then(function (data) {
      if (!data) return;
      var summary = data.summary;
      if (summary && summary.rating_histogram) {
        slot.innerHTML = render(summary);
        wrapper.classList.add('gf-reviews-has-histogram');
      }
      /* Replace Klaviyo's per-review SVG stars with the same layered
         unicode-star markup used in the summary histogram. Match each
         visible review_item to the API result by index (Klaviyo's default
         and our fetch both use sort=3). Re-runs are safe: stars_badge is
         tagged to prevent double-injection. */
      if (data.reviews && data.reviews.length) {
        enhanceReviewStars(data.reviews);
      }
    });
    return true;
  }

  function enhanceReviewStars(reviews) {
    var badges = document.querySelectorAll('#klaviyo-product-reviews-wrapper .kl_reviews__stars_badge');
    for (var i = 0; i < badges.length && i < reviews.length; i++) {
      var badge = badges[i];
      if (badge.dataset.gfStarsInjected) continue;
      badge.dataset.gfStarsInjected = '1';
      badge.innerHTML = '<span class="gf-reviews-stars gf-reviews-stars--inline">'
        + buildStarsHTML(Number(reviews[i].rating) || 0)
        + '</span>';
    }
  }

  /* Klaviyo's widget mounts asynchronously. Poll for ~5s waiting for the
     summary slot to appear. */
  function bootstrap() {
    if (tryInject()) return;
    var attempts = 0;
    var iv = setInterval(function () {
      if (tryInject() || ++attempts > 50) clearInterval(iv);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
